import { render, staticRenderFns } from "./MeetComment.vue?vue&type=template&id=674c6de5&scoped=true"
import script from "./MeetComment.vue?vue&type=script&lang=js"
export * from "./MeetComment.vue?vue&type=script&lang=js"
import style0 from "./MeetComment.vue?vue&type=style&index=0&id=674c6de5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c6de5",
  null
  
)

export default component.exports